import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart, formatPrice } from "../context/CartContext";
import { Minus, Plus, Trash2, ShoppingCart } from "lucide-react";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, removeItem, subtotal, count } = useCart();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="flex w-full flex-col p-0 sm:max-w-md">
        <SheetHeader className="border-b border-navy/10 px-5 py-4">
          <SheetTitle className="font-heading text-navy">
            Your Cart ({count})
          </SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3 p-8 text-center">
            <ShoppingCart size={48} className="text-navy/20" />
            <p className="font-heading text-lg font-semibold text-navy">Your cart is empty</p>
            <p className="text-sm text-navy/50">Add some gear to get started.</p>
            <button
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-navy px-6 py-2.5 text-sm font-semibold text-white hover:bg-navy-light transition-colors"
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-5 py-4">
              {items.map((i) => (
                <div key={i.id} className="flex gap-3 border-b border-navy/10 py-4">
                  <img
                    src={i.image}
                    alt={i.name}
                    className="h-20 w-20 shrink-0 rounded-md border border-navy/10 object-cover"
                  />
                  <div className="flex flex-1 flex-col">
                    <p className="text-sm font-semibold leading-snug text-navy line-clamp-2">{i.name}</p>
                    <p className="mt-1 text-sm font-bold text-brand">{formatPrice(i.price)}</p>
                    <div className="mt-auto flex items-center justify-between">
                      <div className="flex items-center rounded-full border border-navy/15">
                        <button onClick={() => updateQty(i.id, i.qty - 1)} className="p-1.5 text-navy hover:text-brand" aria-label="Decrease"><Minus size={14} /></button>
                        <span className="w-8 text-center text-sm font-semibold">{i.qty}</span>
                        <button onClick={() => updateQty(i.id, i.qty + 1)} className="p-1.5 text-navy hover:text-brand" aria-label="Increase"><Plus size={14} /></button>
                      </div>
                      <button onClick={() => removeItem(i.id)} className="text-navy/40 hover:text-red-500" aria-label="Remove"><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-navy/10 p-5">
              <div className="mb-3 flex items-center justify-between">
                <span className="text-sm text-navy/60">Subtotal</span>
                <span className="font-heading text-xl font-bold text-navy">{formatPrice(subtotal)}</span>
              </div>
              <p className="mb-3 text-xs text-navy/50">Shipping & taxes calculated at checkout.</p>
              <button className="w-full rounded-full bg-brand py-3 font-heading font-bold text-white hover:bg-brand-dark transition-colors">
                Checkout
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
